var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitorLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 173,
    viewBox: "0 0 584 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.294 0L-157 6.03094e-05L-156.435 22.9518C-149.791 16.6304 -126.625 3.85857 -87.1153 3.3421C-47.6054 2.82563 264.533 3.07305 326.374 3.26134L326.294 0Z",
    fill: "url(#paint0_linear_1162_490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.231 18.8594L-137.062 18.8594L-136.498 41.8112C-129.853 35.4898 -106.688 22.7179 -67.1778 22.2015C-27.6679 21.685 284.47 21.9324 346.312 22.1207L346.231 18.8594Z",
    fill: "url(#paint1_linear_1162_490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.171 37.7031L-117.123 37.7032L-116.558 60.6549C-109.914 54.3335 -86.7482 41.5617 -47.2383 41.0452C-7.72848 40.5288 304.41 40.7762 366.251 40.9645L366.171 37.7031Z",
    fill: "url(#paint2_linear_1162_490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.108 56.5625L-97.1855 56.5626L-96.6207 79.5143C-89.9765 73.1929 -66.8107 60.4211 -27.3008 59.9046C12.209 59.3881 324.347 59.6355 386.189 59.8238L386.108 56.5625Z",
    fill: "url(#paint3_linear_1162_490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.048 75.4219L-77.2461 75.4219L-76.6812 98.3737C-70.037 92.0523 -46.8713 79.2804 -7.3614 78.764C32.1485 78.2475 344.286 78.4949 406.128 78.6832L406.048 75.4219Z",
    fill: "url(#paint4_linear_1162_490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.985 94.2734L-57.3086 94.2735L-56.7437 117.225C-50.0995 110.904 -26.9338 98.132 12.5761 97.6155C52.086 97.0991 364.224 97.3465 426.066 97.5348L425.985 94.2734Z",
    fill: "url(#paint5_linear_1162_490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.924 113.125L-37.3691 113.125L-36.8043 136.077C-30.1601 129.755 -6.99432 116.984 32.5156 116.467C72.0254 115.951 384.163 116.198 446.005 116.386L445.924 113.125Z",
    fill: "url(#paint6_linear_1162_490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.288 132.094L-19.0059 132.094L-18.441 155.046C-11.7968 148.724 11.369 135.952 50.8788 135.436C90.3887 134.919 402.527 135.167 464.368 135.355L464.288 132.094Z",
    fill: "url(#paint7_linear_1162_490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.227 150.945L0.933594 150.945L1.49848 173.897C8.14264 167.576 31.3084 154.804 70.8183 154.287C110.328 153.771 422.466 154.018 484.308 154.207L484.227 150.945Z",
    fill: "url(#paint8_linear_1162_490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.165 169.797L20.8711 169.797L21.436 192.749C28.0801 186.427 51.2459 173.655 90.7558 173.139C130.266 172.623 442.404 172.87 504.245 173.058L504.165 169.797Z",
    fill: "url(#paint9_linear_1162_490)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1162_490",
    x1: -134.631,
    y1: 17.5524,
    x2: -123.931,
    y2: -56.8287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1162_490",
    x1: -114.694,
    y1: 36.4118,
    x2: -103.993,
    y2: -37.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1162_490",
    x1: -94.7543,
    y1: 55.2556,
    x2: -84.0537,
    y2: -19.1256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1162_490",
    x1: -74.8168,
    y1: 74.1149,
    x2: -64.1162,
    y2: -0.266179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1162_490",
    x1: -54.8773,
    y1: 92.9743,
    x2: -44.1768,
    y2: 18.5932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1162_490",
    x1: -34.9398,
    y1: 111.826,
    x2: -24.2393,
    y2: 37.4448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1162_490",
    x1: -15.0004,
    y1: 130.677,
    x2: -4.29983,
    y2: 56.2963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1162_490",
    x1: 3.36292,
    y1: 149.646,
    x2: 14.0635,
    y2: 75.2651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1162_490",
    x1: 23.3024,
    y1: 168.498,
    x2: 34.0029,
    y2: 94.1166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1162_490",
    x1: 43.2399,
    y1: 187.349,
    x2: 53.9404,
    y2: 112.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorLines);
export default __webpack_public_path__ + "static/media/visitor_lines.7897ea23f523ed168f38dd59182a4383.svg";
export { ForwardRef as ReactComponent };